<template>
  <div>
    <!-- <eb-select
      :disabled="true"
      type="text"
      v-model="tenant"
      :options="tenantOptions"
      label="label"
      placeholder="Select Tenant"
    ></eb-select>-->
    <!-- <eb-select
      type="text"
      v-model="office.officeType"
      :options="officeOptions"
      label="label"
      placeholder="Select Office Type"
    ></eb-select>-->
    <slot name="name" :data="office.officeName">
      <c-input
        inputType="text"
        inputId="userName"
        lableText="Office Name"
        v-model="office.officeName"
        class="mt-3"
      />
    </slot>
    <b-row class="mt-2" v-for="(p, idx) in office.phone" :key="p + `${idx}`">
      <b-col md="9" class="pr-0">
        <c-tel-input
          v-model="p.number"
          @validate="e => isValidate(e, p)"
          class="m-0"
        />
      </b-col>
      <b-col md="3" class="pl-0">
        <b-button
          btn-special="primary"
          size="lg"
          @click="onClickPhoneButton(p, idx)"
        >
          <i class="fa fa-plus-circle mr-1"></i>
          {{ p.text }}
        </b-button>
      </b-col>
    </b-row>
    <b-row v-for="(e, idx) in office.email" :key="idx">
      <b-col md="9" class="pr-0">
        <c-input
          inputType="text"
          inputId="email"
          lableText="Email"
          v-model="e.mailId"
        />
      </b-col>
      <b-col md="3" class="pl-0">
        <b-button
          btn-special="primary"
          size="lg"
          @click="onClickEamilButton(e, idx)"
        >
          <i class="fa fa-plus-circle mr-1"></i>
          {{ e.text }}
        </b-button>
      </b-col>
    </b-row>
    <div class="streetmargintop">
      <c-input
        type
        inputId="street"
        lableText="Street Line 1"
        class="mt-3"
        v-model="office.address.street1"
      />

      <c-input
        inputType="text"
        inputId="address"
        lableText="Street Line 2"
        class="mt-3"
        v-model="office.address.street2"
      />
    </div>
    <b-row class="mt-2">
      <b-col md="6">
        <c-input
          type="text"
          inputId="hno"
          v-model="office.address.houseNumber"
          lableText="House Number"
        />
      </b-col>
      <b-col md="6">
        <c-input
          inputType="number"
          inputId="zipcode"
          v-model="office.address.zip"
          lableText="Zipcode"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <eb-select
          label="name"
          @input="getCountry"
          :options="countries"
          placeholder="Country"
        ></eb-select>
      </b-col>
    </b-row>
    <b-row class="statemargintop">
      <b-col md="6">
        <eb-select
          label="name"
          @input="getState"
          :options="states"
          placeholder="State"
        ></eb-select>
      </b-col>
      <b-col md="6">
        <eb-select
          placeholder="City"
          :options="cities"
          label="name"
          @input="getCity"
        ></eb-select>
      </b-col>
    </b-row>
    <slot name="footer-button" :data="office">
      <b-button
        class="btn btn-block mt-3"
        btn-color="primary"
        @click="e => $emit('onClickOffice', office)"
        >Next</b-button
      >
    </slot>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "BilltoStepper",

  data() {
    return {
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        officeType: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New"
          }
        ],

        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
            isValid: false
          }
        ],
        address: {
          country: "",
          state: "",
          city: "",
          lat: 0.0,
          lng: 0.0,
          street1: "",
          street2: "",
          zip: "",
          houseNumber: ""
        }
      }
    };
  },
  props: {
    tenants: Array
  },
  components: {
    cInput,
    cTelInput,
    ebSelect
  },
  computed: {
    tenantOptions() {
      return this.tenants
        ? this.tenants.map(t => ({
            label: t.authentication.userName,
            value: t._id
          }))
        : [];
    },
    officeOptions() {
      return [
        {
          label: "Default",
          value: "DEFAULT"
        },
        {
          label: "Head Office",
          value: "HEAD_OFFICE"
        },
        {
          label: "Regional Office",
          value: "REGIONAL_OFFICE"
        },
        {
          label: "Branch Office",
          value: "BRANCH_OFFICE"
        }
      ];
    }
  },
  methods: {
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    getState(payload) {
      this.setCity(payload.id);
      this.office.address.state = payload.name;
    },
    getCity(payload) {
      this.office.address.city = payload.name;
    },
    async setCountry() {
      this.countries = await csc.getAllCountries();
    },
    async setState(id) {
      this.states = await csc.getStatesOfCountry(id);
    },
    async setCity(id) {
      this.cities = await csc.getCitiesOfState(id);
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove"
        });
      else this.office.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove"
        });
      else this.office.phone.splice(idx, 1);
    }
  },
  mounted() {
    this.setCountry();
  }
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #727cf5;
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
